import { render } from "./description.vue?vue&type=template&id=47a92be4&scoped=true"
import script from "./description.vue?vue&type=script&lang=js"
export * from "./description.vue?vue&type=script&lang=js"

import "./description.vue?vue&type=style&index=0&id=47a92be4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a92be4"]])

export default __exports__